import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import { validateStageForm } from "components/admin/configStaging/ConfigStaging.support";
import {
  buildStagePayload,
  stagingErrorMessage,
} from "components/admin/userConfig/StageConfigDialog.support";
import Button from "components/common/Button";
import TextField from "components/common/TextField";
import { useEffect, useState } from "react";
import { useCreateStagedConfigMutation } from "services/adminService";

const StageConfigDialog = ({
  open,
  onClose,
  companyId,
  staticDataKey,
  getData,
  initialReason,
  changeType = "config",
}) => {
  const [title, setTitle] = useState("");
  const [prInput, setPrInput] = useState("");
  const [githubLink, setGithubLink] = useState("");
  const [reason, setReason] = useState("");
  const [errors, setErrors] = useState({});
  const [
    createStagedConfig,
    { isLoading, isError, error, reset },
  ] = useCreateStagedConfigMutation();

  useEffect(() => {
    if (open) {
      setTitle("");
      setPrInput("");
      setGithubLink("");
      setReason(initialReason ?? "");
      setErrors({});
      reset();
    }
  }, [open, initialReason, reset]);

  const submit = () => {
    const { valid, errors: formErrors, prNumbers } = validateStageForm({
      title,
      prInput,
      githubLink,
      reason,
    });
    setErrors(formErrors);
    if (!valid) return;
    createStagedConfig(
      buildStagePayload({
        companyId,
        changeType,
        staticDataKey,
        data: getData(),
        title,
        prNumbers,
        githubLink,
        reason,
      })
    )
      .unwrap()
      .then(() => onClose(true))
      .catch(() => {});
  };

  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      fullWidth
      maxWidth={"sm"}
    >
      <DialogTitle>{"Stage Config"}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0 }}>
          {isError && (
            <Grid item xs={12}>
              <Alert severity={"error"}>{stagingErrorMessage(error)}</Alert>
            </Grid>
          )}
          <Grid item xs={12}>
            <TextField
              label={"Title"}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              error={Boolean(errors.title)}
              helperText={errors.title}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label={"PR numbers"}
              value={prInput}
              onChange={(e) => setPrInput(e.target.value)}
              error={Boolean(errors.prInput)}
              helperText={errors.prInput ?? "Comma-separated, e.g. 7591, 7602"}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label={"GitHub link"}
              value={githubLink}
              onChange={(e) => setGithubLink(e.target.value)}
              error={Boolean(errors.githubLink)}
              helperText={errors.githubLink}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label={"Reason"}
              multiline
              minRows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              error={Boolean(errors.reason)}
              helperText={errors.reason}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button color={"secondary"} onClick={() => onClose(false)}>
          {"Cancel"}
        </Button>
        <Button
          color={"primary"}
          isLoading={isLoading}
          hasError={isError}
          onClick={submit}
        >
          {"Stage Config"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StageConfigDialog;
